import PropTypes from 'prop-types'
import React from 'react'
import { formatPhone } from 'SRC/modules/layout/Sidebar/AdsList/functions/functions'

export const Agent = ({ agent: { name, phone, email, image } }) => (
  <div className='oglasi-agent'>
    <div className='oglasi-info-heading'>
      <p>Agent</p>
    </div>

    <section className='oglasi-agent-info'>
      <div className='oglasi-agent-img' style={{backgroundImage: `url(${image})`}} />
      <div className='oglasi-agent-description'>
        <p>
          <i className='ico ico-top-meni-prijavi-se' style={{ fontSize: 20 }} />
          <span>{name}</span>
        </p>
        {phone ? (
          <p>
            <img src='/icons/Partneri-Telefon.svg' width={20} />
            <span>{formatPhone(phone)}</span>
          </p>
        ) : null}
        {email ? (
          <p>
            <img src='/icons/Partneri-Email.svg' width={20} />
            <span>{email}</span>
          </p>
        ) : null}
      </div>
    </section>
  </div>
)

Agent.propTypes = {
  agent: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    phone: PropTypes.string,
    email: PropTypes.string,
    image: PropTypes.string
  }).isRequired
}
